<template>
    <ul>
        <li class="nav-item" v-for="(item, index) in navItemsComputed" :key="index" :class="{'nav-dropdown': item.children && item.children.length > 0, 'open': item.isOpen}">
            <template v-if="item.children && item.children.length > 0">
                <div class="nav-link nav-link-main nav-dropdown-toggle" @click="toggleNavItm(item)">
                    <i class="nav-icon" :class="item.icon" v-if="item.icon"></i>
                    <span>{{ item.name }}</span>
                    <span class="badge" v-if="item.badgeNumber" :class="{'badge-warning': item.badgeColor == 'warning','badge-danger': item.badgeColor != 'warning'}">{{ item.badgeNumber }}</span>
                </div>
                <MySidebarChildren class="nav-dropdown-items" :nav-items.sync="item.children"></MySidebarChildren>
            </template>
            <template v-else>
                <router-link :to="item.url" class="nav-link nav-link-main">
                    <i class="nav-icon" :class="item.icon" v-if="item.icon"></i>
                    <span>{{ item.name }}</span>
                    <span class="badge" v-if="!item.badgeUrl && item.badgeNumber" :class="{'badge-warning': item.badgeColor == 'warning','badge-danger': item.badgeColor != 'warning'}">{{ item.badgeNumber }}</span>
                </router-link>
                <router-link :to="item.badgeUrl" class="nav-link nav-link-badge" v-if="item.badgeUrl && item.badgeNumber">
                    <span class="badge" :class="{'badge-warning': item.badgeColor == 'warning','badge-danger': item.badgeColor != 'warning'}">{{ item.badgeNumber }}</span>
                </router-link>
            </template>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'MySidebarChildren',
    props: {
        navItems: {
            type: Array,
            required: true
        }

    },
    methods: {
        toggleNavItm(itm) {
            itm.isOpen = !itm.isOpen;
        }
    },
    computed: {
        navItemsComputed: {
            get() {
                var currNavItems = this.navItems;
                return currNavItems;
            },
            set(val) {
                console.log('set navItemsComputed', val)
                this.navItems = val;
                this.$emit('update:navItems', this.navItems);
            }
        },
    }
}
</script>